import { FC, useEffect, useState } from 'react'
import css from 'classnames'
import { Props } from './types'

export const Switcher: FC<Props> = ({
  id = Date.now().toString(),
  label,
  onChange,
  defaultValue = false,
  labelClassNames,
  containerClassNames,
  switcherClassNames,
  disabled = false,
}) => {
  const [enabled, setEnabled] = useState(defaultValue)

  useEffect(() => {
    setEnabled(defaultValue)
  }, [defaultValue])

  const handleClick = () => {
    if (!disabled) {
      setEnabled(!enabled)
      onChange?.(!enabled)
    }
  }

  return (
    <div className={css('flex gap-3 items-center', containerClassNames)}>
      <span
        onClick={handleClick}
        className={css(labelClassNames, 'cursor-pointer')}
      >
        {label}
      </span>
      <label
        htmlFor={id}
        className={css(
          'inline-flex relative items-center mr-5 cursor-pointer',
          switcherClassNames,
        )}
      >
        <input
          id={id}
          type="checkbox"
          className="sr-only peer"
          checked={enabled}
          readOnly
          disabled={disabled}
        />
        <div
          onClick={handleClick}
          className={`w-12 h-6 border border-gray-600 rounded-full peer ${
            disabled ? 'pointer-events-none opacity-50' : ''
          } peer-checked:after:translate-x-full peer-checked:after:border-white-600 after:content-[''] after:absolute after:top-1 after:left-[5px] peer-checked:after:left-[10px] after:bg-gray-500 after:border-gray-500 peer-checked:after:border-white peer-checked:after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600 peer-checked:border-blue-600`}
        />
      </label>
    </div>
  )
}
